import Localization from 'lib/localization';

export default {
    lxSeoPageDescriptionIndex(params: { page_partner_name: string }) {
        return Localization.get('badoo_safety_center@seo.page.description.index', params);
    },
    lxSeoPageDescriptionGuidesSectionHarmfulBehaviour(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.harmful_behaviour',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionHarmfulBehaviourArticleTwo(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.harmful_behaviour.article.two',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionHarmfulBehaviourArticleThree(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.harmful_behaviour.article.three',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionHarmfulBehaviourArticleFourth(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.harmful_behaviour.article.fourth',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionHarmfulBehaviourArticleFifth(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.harmful_behaviour.article.fifth',
            params
        );
    },

    lxSeoPageDescriptionGuidesSectionMeetingInRealLife(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.meeting_in_real_life',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionMeetingInRealLifeArticleTwo(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.meeting_in_real_life.article.two',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionMeetingInRealLifeArticleThree(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.meeting_in_real_life.article.three',
            params
        );
    },

    lxSeoPageDescriptionGuidesSectionSafetyTips(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.safety_tips',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionSafetyTipsArticleTwo(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.safety_tips.article.two',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionSafetyTipsArticleThree(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.safety_tips.article.three',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionSafetyTipsArticleFourth(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.safety_tips.article.fourth',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionSafetyTipsArticleFifth(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.safety_tips.article.fifth',
            params
        );
    },

    lxSeoPageDescriptionGuidesSectionMentalWellbeing(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.mental_wellbeing',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionMentalWellbeingArticleTwo(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.mental_wellbeing.article.two',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionMentalWellbeingArticleThree(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.mental_wellbeing.article.three',
            params
        );
    },
    lxSeoPageDescriptionGuidesSectionMentalWellbeingArticleFourth(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.description.guides.section.mental_wellbeing.article.fourth',
            params
        );
    },
};
